<!--
 * @Description: 服务事项编辑内容dialog组件
 * @Author: sunhuihong
 * @Date: 2022-09-05 07:43:52
 * @LastEditTime: 2023-12-19 14:49:19
-->
<template>
  <el-dialog width="570px" title="修改内容" :visible.sync="showEditContentDialog" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel" center>
    <el-form :rules="rules" :model="ruleForm" ref="ruleForm" style="margin: 0 25px 30px 25px;">
      <el-form-item  prop="content" >
        <div style="font-size: 14px; color: #657180; line-height: 20px; margin-bottom: 12px;">注意事项:</div>
        <el-input  type="textarea" v-model="ruleForm.content"  maxlength="500" :rows="16" placeholder="请输入注意事项">
        </el-input>
      </el-form-item>
    </el-form>
    <div  class="dialog-footer bk-wizard-bottons">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSave('ruleForm')">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Constant from '@/global/Constant.js'

export default {
  name: "EditContentDialog",
  props: ["showEditContentDialog", "serviceItemId", "institutionId"],
  data() {
    let validateContent = (_rule, _value, callback) => {
		  if (this.ruleForm.content && this.ruleForm.content.trim().length == 0) {
		  	callback(new Error('注意事项不能输入全空格或全换行'));
		  } else if (this.ruleForm.content == '') {
		  	callback(new Error('请输入注意事项'));
		  } else {
        callback();
      }
    };

    return {
      ruleForm: {
        content: '',
        institutionId: ''
      },
      rules: {
        content: [
          { required: true, validator: validateContent, trigger: 'blur'},
          { min: 1, max: 500, message: '长度在 1 到 500个字符', trigger: 'blur' }
        ],     
      },
    };
  },

  methods : {
    //获取编辑接口数据
    initData() {
      let params = {id: this.serviceItemId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_MATTER,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result != null) {
          this.ruleForm = result.data == null ? {} : result.data;
        }
      });
    },

    handleSave(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (!valid) return false;
        this.ruleForm.institutionId = this.institutionId;
        let header = this.encryptionUtil.signatureBody(this.ruleForm,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'PUT',
          url: Constant.URL_UPDATE_MATTER,
          param: this.ruleForm,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };

        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.clearData();
            this.$emit("handle-close-edit-content-dialog", true);
          }
        });
      });
    },

    //清空
    clearData() {
      this.ruleForm = {};
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },

    handleCancel() {
       this.clearData();
       this.$emit("handle-close-edit-content-dialog", false);
    }
  }
}
</script>

<style scoped>
.dialog-footer {
	text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/hsvcmng/components/hsvcmatter/EditContentDialog.vue